export default __webpack_public_path__ + "static/media/juego5_ganar.f21af15d.png";